import { useState } from "react";

export const useThemeModal = () => {
  const [themeModalVisible, setThemeModalVisible] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState<string>("");
  const [selectedThemeProvider, setSelectedThemeProvider] = useState<string>("");

  const showThemeModal = (themeString: string, provider: string) => {
    setSelectedTheme(themeString);
    setSelectedThemeProvider(provider);
    setThemeModalVisible(true);
  };

  const hideThemeModal = () => {
    setThemeModalVisible(false);
    setSelectedTheme("");
    setSelectedThemeProvider("");
  };

  return {
    themeModalVisible,
    selectedTheme,
    selectedThemeProvider,
    showThemeModal,
    hideThemeModal,
  };
}; 